import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { config } from 'src/app/config/config';
@Injectable({
  providedIn: 'root'
})
export class SgrbService {

  config = config;
  
  constructor( private http : HttpClient) { }

  submitTrade(tradeObj:any){
    let URL = environment.URL + this.config.URL.saveSgrbTrade;
    return this.http.post(URL, tradeObj);
  }

  getAllSgrbTrade(){
    let URL = environment.URL + this.config.URL.getAllSgrbTrades;
    return this.http.get(URL);
  }

  getSgrbFilteredTrade(reqObj:any){
    let URL = environment.URL + this.config.URL.getSgrbFilteredTrade;
    return this.http.post(URL,reqObj);
  }

  rejectTrade(id:any)
  {
    let URL = environment.URL + this.config.URL.rejectSgrbTrade+"/"+id;
    return this.http.get(URL);
  }

  approveTrade(id:any)
  {
    let URL = environment.URL + this.config.URL.approveSgrbTrade+"/"+id;
    return this.http.get(URL);
  }

  getSgrbTrade(id:any)
  {
    let URL = environment.URL + this.config.URL.getSgrbTrade+"/"+id;
    return this.http.get(URL);
  }
}